import { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

const SiteBanGuard = () => {
  const { isSiteBanned } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isSiteBanned && location.pathname !== '/suspended') {
      navigate('/suspended', { replace: true });
    }
  }, [isSiteBanned, location.pathname, navigate]);

  return null;
};

export default SiteBanGuard;
